import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { translate } from '../../helpers/stringHelpers'
import { millisToLocaleString } from '../../helpers/dateHelpers'

const COUNTDOWN_CLASS_NAME = 'listing-card__countdown'

const CountdownAuctionStarts = ({ completed, endsAt, startsAt }) => completed
  ? null
  : (
    <span className={`${COUNTDOWN_CLASS_NAME}`}>
      <span className={`${COUNTDOWN_CLASS_NAME}--end`}>{translate('JspPublicCodes_COUNTDOWN_ENDS')} {millisToLocaleString(endsAt)}</span>
      <br /><small className={`${COUNTDOWN_CLASS_NAME}--start`}>{translate('JspPublicCodes_COUNTDOWN_STARTS')} {millisToLocaleString(startsAt)}</small>
    </span>
    )

CountdownAuctionStarts.propTypes = {
  completed: PropTypes.bool.isRequired,
  endsAt: PropTypes.number.isRequired,
  startsAt: PropTypes.number.isRequired
}

export default memo(CountdownAuctionStarts)
